/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyUserInfo,
    JsonCompanyUserInfoFromJSON,
    JsonCompanyUserInfoFromJSONTyped,
    JsonCompanyUserInfoToJSON,
} from './JsonCompanyUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyUserInfo
 */
export interface ApiResultOfJsonCompanyUserInfo {
    /**
     * 
     * @type {JsonCompanyUserInfo}
     * @memberof ApiResultOfJsonCompanyUserInfo
     */
    data?: JsonCompanyUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyUserInfo
     */
    result?: ApiResultOfJsonCompanyUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyUserInfoFromJSON(json: any): ApiResultOfJsonCompanyUserInfo {
    return ApiResultOfJsonCompanyUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyUserInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyUserInfoToJSON(value?: ApiResultOfJsonCompanyUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyUserInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

